





















import { Vue, Component } from 'vue-property-decorator';
import { Getter } from 'vuex-class';

@Component({})
export default class IncompleteCourseDetailsWarning extends Vue {
  @Getter('course/missingRequiredCourseLevelAttributes')
  missingAttributes!: string[];
}
